import React from "react";

import Menus from "../../Components/pages/menus/menus";

function Index() {
  return <Menus />;
}

export default Index;
